var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"radius-6 text-base-white m-r-6 p-y-9",class:[_vm.btnClasses, { 'is-small': _vm.isSmall }],attrs:{"id":`${_vm.action}-btn`,"type":"submit"},on:{"click":_vm.actionHandler}},[_c('span',{staticClass:"p-base-medium"},[_vm._v(_vm._s(_vm.$t(`buttons.${_vm.action.toLowerCase()}`)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }